export default "__VITE_ASSET__BaCMEGHf__"